import React, { useState } from 'react';
import { Check, X, ArrowRight, Clock, Target, Shield, BarChart3, Users, Layers, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
export function AdvantageProduct() {
  const [isPartialCampaign, setIsPartialCampaign] = useState(false);
  return <div className="min-h-screen w-full bg-[#0B1120] text-slate-200 selection:bg-emerald-500/30 font-sans" data-id="element-362">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-363">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-emerald-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-364" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-365">
          <div className="inline-block px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-366">
            Flagship Partnership
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-367">
            HIRE Advantage
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-368">
            Recruiting stops being a scramble when someone owns the system — not
            just the traffic.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-369">
            HIRE Advantage is the partnership where recruiting becomes
            consistent, predictable, and scalable.
          </p>
        </motion.div>
      </section>

      {/* 2. PROBLEM REFRAME */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto border-t border-slate-800/50" data-id="element-370">
        <div className="text-center mb-12" data-id="element-371">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-372">
            The Real Problem
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-373">
            Most companies don't fail at finding candidates. They fail at system
            execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-374">
          <div className="bg-slate-900/30 border border-slate-800 p-8 rounded-xl" data-id="element-375">
            <h3 className="text-sm text-rose-400 uppercase tracking-widest font-bold mb-6" data-id="element-376">
              System Failures
            </h3>
            <ul className="space-y-4" data-id="element-377">
              {['Inconsistent interviews', 'Drifting hiring standards', 'Early churn discovered too late', 'Leaders relying on gut decisions'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-378">
                  <X className="w-5 h-5 text-rose-500/50 mr-3 mt-0.5 flex-shrink-0" data-id="element-379" />
                  <span className="line-through opacity-70" data-id="element-380">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="flex flex-col justify-center p-8" data-id="element-381">
            <p className="text-xl text-white font-medium mb-4" data-id="element-382">
              Advantage solves the system failure, not just the talent shortage.
            </p>
            <p className="text-slate-400" data-id="element-383">
              We replace guesswork with infrastructure and accountability.
            </p>
          </div>
        </div>
      </section>

      {/* 3. WHAT ADVANTAGE IS */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-384">
        <div className="max-w-5xl mx-auto" data-id="element-385">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-386">
            <div data-id="element-387">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-388">
                Full System Ownership
              </h2>
              <div className="space-y-4 text-slate-400 mb-8" data-id="element-389">
                <p data-id="element-390">This is not lead generation.</p>
                <p data-id="element-391">This is not outsourced recruiting.</p>
                <p data-id="element-392">This is full ownership of the recruiting system.</p>
              </div>
              <div className="p-6 bg-emerald-500/5 border border-emerald-500/20 rounded-lg" data-id="element-393">
                <p className="text-emerald-400 font-medium" data-id="element-394">
                  HIRE Advantage is the only partnership level where HIRE is
                  accountable for the recruiting system actually working.
                </p>
              </div>
            </div>
            <div className="space-y-6" data-id="element-395">
              <div className="flex items-start" data-id="element-396">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-397">
                  <Shield className="w-6 h-6 text-emerald-400" data-id="element-398" />
                </div>
                <div data-id="element-399">
                  <h3 className="text-white font-bold mb-2" data-id="element-400">Accountability</h3>
                  <p className="text-slate-400 text-sm" data-id="element-401">
                    We don't just deliver leads; we own the outcome of the
                    system's performance.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-402">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-403">
                  <Target className="w-6 h-6 text-emerald-400" data-id="element-404" />
                </div>
                <div data-id="element-405">
                  <h3 className="text-white font-bold mb-2" data-id="element-406">Consistency</h3>
                  <p className="text-slate-400 text-sm" data-id="element-407">
                    Eliminating the variance between good weeks and bad weeks.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. 10-STEP SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-408">
        <div className="text-center mb-12" data-id="element-409">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-410">
            The 10-Step Recruiting System
          </h2>
          <p className="text-slate-400" data-id="element-411">
            Every HIRE Advantage partner runs the same system. The difference is
            who owns it.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-412">
          {['Attract', 'Engage', 'Screen', 'Qualify', 'Commit', 'Schedule', 'Launch', 'Integrate', 'Train', 'Retain'].map((step, idx) => <div key={idx} className="bg-slate-900/40 border border-slate-800 p-6 rounded-lg text-center hover:border-emerald-500/30 transition-colors group" data-id="element-413">
              <div className="text-xs text-slate-500 mb-2 font-mono" data-id="element-414">
                0{idx + 1}
              </div>
              <div className="text-white font-medium group-hover:text-emerald-400 transition-colors" data-id="element-415">
                {step}
              </div>
            </div>)}
        </div>
      </section>

      {/* 5. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-416">
        <div className="max-w-6xl mx-auto" data-id="element-417">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-418">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-419">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-emerald-500/20 rounded-xl p-8 relative overflow-hidden" data-id="element-420">
              <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500" data-id="element-421" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-422">
                <span className="w-2 h-2 rounded-full bg-emerald-500 mr-3" data-id="element-423" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-424">
                {['Recruiting system architecture (custom ATS)', 'Traffic, screening, and qualification standards', 'Hiring consistency and interview structure', 'Sales School and launch readiness', 'Early performance tracking and correction', 'Ongoing optimization and accountability'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-425">
                    <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-426" />
                    <span data-id="element-427">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 relative overflow-hidden" data-id="element-428">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-429" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-430">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-431" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-432">
                {['Final hiring decisions', 'Day-to-day sales leadership', 'Culture and performance expectations'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-433">
                    <div className="w-5 h-5 rounded-full bg-slate-800 border border-slate-700 mr-3 mt-0.5 flex-shrink-0 flex items-center justify-center" data-id="element-434">
                      <div className="w-1.5 h-1.5 rounded-full bg-slate-500" data-id="element-435" />
                    </div>
                    <span data-id="element-436">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 6. TIMELINE */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-437">
        <h2 className="text-3xl font-bold text-white mb-16 text-center" data-id="element-438">
          Partnership Timeline
        </h2>

        <div className="relative" data-id="element-439">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-slate-800 -translate-x-1/2 hidden md:block" data-id="element-440" />

          <div className="space-y-12" data-id="element-441">
            {[{
            days: 'Days 1–21',
            title: 'Build & Launch',
            items: ['System architecture build', 'Campaign launch', 'Sales School setup', 'First candidates generated']
          }, {
            days: 'Weeks 4–12',
            title: 'Support & Consulting',
            items: ['Weekly support and consulting', 'Establishing strong baseline KPIs', 'Interviewing 30+ triple screened prospects/mo', 'Hiring 15+ people/mo']
          }, {
            days: 'Month 3+',
            title: 'Optimization',
            items: ['Increase conversion rates', 'Improve retention', 'Maximize ROI', 'Scale successful patterns']
          }].map((phase, idx) => <div key={idx} className={`flex flex-col md:flex-row items-center ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-442">
                <div className="w-full md:w-1/2 p-4 md:p-8" data-id="element-443">
                  <div className={`bg-slate-900/30 border border-slate-800 p-6 rounded-xl ${idx % 2 === 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-444">
                    <div className="text-emerald-400 font-bold text-sm uppercase tracking-widest mb-2" data-id="element-445">
                      {phase.days}
                    </div>
                    <h3 className="text-xl font-bold text-white mb-4" data-id="element-446">
                      {phase.title}
                    </h3>
                    <ul className={`space-y-2 ${idx % 2 === 0 ? '' : 'md:flex md:flex-col md:items-end'}`} data-id="element-447">
                      {phase.items.map((item, i) => <li key={i} className="text-slate-400 text-sm flex items-center" data-id="element-448">
                          {idx % 2 !== 0 && <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-slate-700 ml-2 order-2" data-id="element-449" />}
                          <span className={idx % 2 !== 0 ? 'md:mr-0' : ''} data-id="element-450">
                            {item}
                          </span>
                          {(idx % 2 === 0 || window.innerWidth < 768) && <span className="w-1.5 h-1.5 rounded-full bg-slate-700 ml-2 md:ml-0 md:mr-2 md:order-first" data-id="element-451" />}
                        </li>)}
                    </ul>
                  </div>
                </div>
                <div className="w-8 h-8 rounded-full bg-slate-900 border-4 border-slate-800 z-10 hidden md:block" data-id="element-452" />
                <div className="w-full md:w-1/2" data-id="element-453" />
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. PRICING */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-454">
        <div className="max-w-6xl mx-auto" data-id="element-455">
          <div className="text-center mb-12" data-id="element-456">
            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-457">
              Partnership Pricing
            </h2>
            <p className="text-slate-400" data-id="element-458">
              Recruiting stops being a scramble when someone owns the system —
              not just the traffic.
            </p>
          </div>

          <div className="flex justify-center mb-12" data-id="element-459">
            <div className="bg-slate-900/50 p-1 rounded-lg border border-slate-800 flex items-center" data-id="element-460">
              <button onClick={() => setIsPartialCampaign(false)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${!isPartialCampaign ? 'bg-emerald-500 text-white shadow-lg' : 'text-slate-400 hover:text-white'}`} data-id="element-461">
                Full Campaign
              </button>
              <button onClick={() => setIsPartialCampaign(true)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${isPartialCampaign ? 'bg-emerald-500 text-white shadow-lg' : 'text-slate-400 hover:text-white'}`} data-id="element-462">
                Partial Campaign
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-463">
            {/* Build Fee */}
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-464">
              <div className="mb-4" data-id="element-465">
                <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-466">
                  Build (One-Time)
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-467">$5,000</div>
                <div className="mt-4 inline-flex items-center px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-bold" data-id="element-468">
                  <Shield className="w-3 h-3 mr-1.5" data-id="element-469" />
                  Money Back Guarantee
                </div>
              </div>
            </div>

            {/* Monthly Total */}
            <div className="bg-slate-900/40 border border-emerald-500/30 p-6 rounded-xl relative" data-id="element-470">
              <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500 rounded-t-xl" data-id="element-471" />
              <div className="mb-4" data-id="element-472">
                <div className="text-xs text-emerald-500 uppercase tracking-widest mb-2" data-id="element-473">
                  Total Monthly
                </div>
                <div className="text-4xl font-bold text-white mb-1" data-id="element-474">
                  ${isPartialCampaign ? '3,750' : '5,000'}
                </div>
                <div className="text-sm text-slate-500 mb-6" data-id="element-475">/ month</div>

                <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-476">
                  <div className="flex justify-between text-sm" data-id="element-477">
                    <span className="text-slate-400" data-id="element-478">System Fee</span>
                    <span className="text-white font-medium" data-id="element-479">$2,500</span>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-480">
                    <span className="text-slate-400" data-id="element-481">
                      {isPartialCampaign ? 'Partial' : 'Full'} Campaign
                    </span>
                    <span className="text-white font-medium" data-id="element-482">
                      ${isPartialCampaign ? '1,250' : '2,500'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Performance Bonuses */}
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-483">
              <div className="mb-4" data-id="element-484">
                <div className="text-xs text-amber-400 uppercase tracking-widest mb-4" data-id="element-485">
                  Performance Bonuses
                </div>
                <ul className="space-y-3" data-id="element-486">
                  <li className="flex items-start" data-id="element-487">
                    <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-488">
                      $250
                    </span>
                    <span className="text-slate-300 text-lg" data-id="element-489">
                      per rep at launch
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-490">
                    <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-491">
                      $250
                    </span>
                    <span className="text-slate-300 text-lg" data-id="element-492">
                      per rep at 30 days
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-493">
                    <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-494">
                      $250
                    </span>
                    <span className="text-slate-300 text-lg" data-id="element-495">
                      per rep at 60 days
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-496">
                    <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-497">
                      $250
                    </span>
                    <span className="text-slate-300 text-lg" data-id="element-498">
                      per rep at 90 days
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-8 p-6 bg-emerald-500/5 border border-emerald-500/20 rounded-lg max-w-3xl mx-auto" data-id="element-499">
            <p className="text-emerald-400 text-center font-medium" data-id="element-500">
              Bonuses are only paid when reps reach real performance milestones.
            </p>
          </div>
        </div>
      </section>

      {/* 8. WHO THIS IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-501">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-502">
          <div data-id="element-503">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-504">
              <Check className="w-5 h-5 text-emerald-500 mr-2" data-id="element-505" />
              This is for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-506">
              {['Want recruiting to actually work', 'Value consistency over heroics', 'Are open to better systems', 'Want a partner, not a vendor'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-507">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-3 mt-2" data-id="element-508" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-509">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-510">
              <X className="w-5 h-5 text-rose-500 mr-2" data-id="element-511" />
              This is not for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-512">
              {['Only want resumes', "Aren't open to process", 'Want zero accountability'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-513">
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-500 mr-3 mt-2" data-id="element-514" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 9. HOW THIS SCALES */}
      <section className="py-16 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800 text-center" data-id="element-515">
        <div className="max-w-3xl mx-auto" data-id="element-516">
          <h2 className="text-2xl font-bold text-white mb-8" data-id="element-517">
            How This Scales
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-6 text-left" data-id="element-518">
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-519">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-520">
                Infrastructure
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-521">Edge</h3>
              <p className="text-slate-400 text-sm" data-id="element-522">
                Exists for infrastructure-only needs.
              </p>
            </div>
            <div className="flex-1 p-6 border border-emerald-500/30 rounded-lg bg-slate-800/30" data-id="element-523">
              <div className="text-xs text-emerald-500 uppercase tracking-widest mb-2" data-id="element-524">
                Foundation
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-525">Advantage</h3>
              <p className="text-slate-400 text-sm" data-id="element-526">
                The foundation that makes both work.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-527">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-528">
                Execution
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-529">Summit</h3>
              <p className="text-slate-400 text-sm" data-id="element-530">
                Exists when execution capacity is the bottleneck.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 10. CTA */}
      <section className="py-32 px-6 md:px-12 text-center" data-id="element-531">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-532">
          Ready to make recruiting predictable?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-533">
          Let's see if Advantage is the right fit
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-534" />
        </button>
      </section>
    </div>;
}